import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../config';
import { LoanInventoryTableFields } from '../types';

const apiClientConfig: ApiClientConfig = {
  timeout: config.validationMasterPoolAPi.requestTimeout
};

const loansInventoryUrl: string = config.validationMasterPoolAPi.urls.masterPoolLoansInventory;

type RequestPropsTableData = {
  authenticationContext: AuthenticationContextType;
  masterPoolAccountNumber: string;
  queryParams: string;
};

const inventoryTimeout: number = config.validationMasterPoolAPi.requestTimeout;

export const getLoanInventoryTableData = async ({
  authenticationContext,
  masterPoolAccountNumber,
  queryParams
}: RequestPropsTableData): Promise<LoanInventoryTableFields[]> => {
  try {
    let requestQuery;
    requestQuery = `${loansInventoryUrl}/${masterPoolAccountNumber}/loans/search${queryParams}`;

    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestQuery,
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error getting Loan inventory table data');
    // eslint-disable-next-line
    console.error('Error getting Loan inventory table data :', err);
    return [];
  }
};
